import { render } from "./MyNotesArchive.vue?vue&type=template&id=17439fb0&scoped=true"
import script from "./MyNotesArchive.vue?vue&type=script&lang=js"
export * from "./MyNotesArchive.vue?vue&type=script&lang=js"

import "./MyNotesArchive.vue?vue&type=style&index=0&id=17439fb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17439fb0"]])

export default __exports__